import Vue from "vue";
import VideoConverter from "@/lib/VideoConverter";
import ImageConverter from "@/lib/ImageConveter";
import WordConverter from "@/lib/WordConverter";
import pptConverter from "@/lib/PptConverter";
import pdfConverter from "@/lib/PdfConverter";
import {watchLocal} from "../../common/utils";
import {membasicinfo, memorder} from "../sdk";
import Dialog from "./Dialog";
import Toast from "./Toast";
console.log(process.env.VUE_APP_language);
const store = new Vue({
	data: {
		local: watchLocal("local.config", {
			outputPath: ``, // 保存至
			outputOriginDir: "true", // true: 保存至原文件夹 false: 使用outputPath设置
			userLoginData: null,
			userPayTime: "", //订单支付时间
			detainData: null,
		}),
		isYsOver: true,
		isDrOver: true,
		toast: new Toast(),
		dialog: new Dialog(),
		loading: 0, // 加载中modal
		drawer: false, // 侧边菜单
		isFenBianLvChangeOver: true,
		isFullScreen: false,
		isNet: true,
		theWayToShop: "",
		clearFileList: {
			tpFileList: watchLocal("image-converter", new ImageConverter()),
			spFileList: watchLocal("video-converter", new VideoConverter()),
			wordFileList: watchLocal("word-converter", new WordConverter()),
			pptFileList: watchLocal("ppt-converter", new pptConverter()),
			pdfFileList: watchLocal("pdf-converter", new pdfConverter()),
		},
		language: !(process.env.VUE_APP_language == "zh-CN"),
		productName: "迅捷压缩",
	},
	computed: {
		isLogin() {
			return !!this.local.userLoginData;
		},
		// 剩余会员时间
		vipRest() {
			let data = this.local.userLoginData;
			if (!data || !data.vip.length) return 0;
			let expireAt = data.vip[0].auth_value * 1000;
			// console.log(data.vip[0].auth_value * 1000, "到期时间");
			return expireAt - Date.now();
			// return expireAt - this.userPayTime;
		},
		// 0是普通用户(无vip)，1是月vip，3是年vip，2是永久vip
		VIPlevel() {
			if (this.vipRest > 315360000000) return 2;
			if (this.vipRest > 31536000000) return 3;
			if (this.vipRest > 0) return 1;
			return 0;
		},
		VIPState() {
			if (this.isLogin) {
				let is_vip = this.VIPlevel > 0 ? "已登录VIP" : "已登录非VIP";
				return is_vip;
			} else return "未登录";
		},
		nowSeceen() {
			return window.screen;
		},
	},
	watch: {
		language: {
			immediate: true,
			handler() {
				console.log(this.productName, document.title, this.language, navigator.language);
				this.productName = document.title = this.language
					? navigator.language.substr(0, 2) == "zh"
						? "迅捷壓縮"
						: "WorkinTool File Compressor"
					: "迅捷压缩";
			},
		},
	},
	methods: {
		setUserInfo(data) {
			this.local.userLoginData = data;
		},
		getUserInfo() {
			// console.log("更新用户信息");
			let user = this.local.userLoginData;
			if (!user) return Promise.resolve();
			return membasicinfo({
				account: user.username,
				usertoken: user.usertoken,
			}).then((user) => {
				return this.setUserInfo(user);
			});
		},
		setMemorder(data) {
			let arr = data.map((item) => {
				return item.paytime;
			});
			console.log(arr);
			// this.local.userPayTime = arr[arr.length - 1] * 1000;
			this.local.userPayTime = arr[0] * 1000;
			// console.log(this.local.userPayTime, "支付时间");
		},
		//获取用户订单支付时间
		getMemorder() {
			let user = this.local.userLoginData;
			if (!user) return Promise.resolve();
			return memorder({
				account: user.username,
				usertoken: user.usertoken,
			}).then((userpay) => {
				return this.setMemorder(userpay);
			});
		},
		clearAll() {
			return new Promise((resolve, reject) => {
				let clearlist = this.clearFileList;
				if (clearlist.spFileList) {
					clearlist.spFileList.clear();
				}
				if (clearlist.tpFileList) {
					clearlist.tpFileList.clear();
				}
				if (clearlist.wordFileList) {
					clearlist.wordFileList.clear();
				}
				if (clearlist.pptFileList) {
					clearlist.pptFileList.clear();
				}
				if (clearlist.pdfFileList) {
					clearlist.pdfFileList.clear();
				}
				setTimeout(() => {
					resolve("清理结束");
				}, 500);
			});
		},
		// async getAlluserInfo() {

		// },
	},
});

window.store = store;

export default store;
